(function () {
    'use strict';

    var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
    var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

    /* ---------- Sticky header + back to top ---------- */
    var header = $('#siteHeader');
    var toTop = $('#toTop');

    function onScroll() {
        var y = window.pageYOffset;
        header.classList.toggle('is-sticky', y > 60);
        toTop.classList.toggle('is-visible', y > 600);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    toTop.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    /* ---------- Mobile menu ---------- */
    var nav = $('#mainNav');
    var toggle = $('#navToggle');
    var overlay = $('#navOverlay');

    function setMenu(open) {
        nav.classList.toggle('is-open', open);
        overlay.classList.toggle('is-visible', open);
        document.body.classList.toggle('nav-open', open);
        toggle.setAttribute('aria-expanded', open);
    }

    toggle.addEventListener('click', function () { setMenu(true); });
    $('#navClose').addEventListener('click', function () { setMenu(false); });
    overlay.addEventListener('click', function () { setMenu(false); });

    // Tap "Services" on mobile to expand its submenu
    $$('.has-children > a', nav).forEach(function (link) {
        link.addEventListener('click', function (e) {
            if (window.innerWidth < 992) {
                e.preventDefault();
                link.parentElement.classList.toggle('is-expanded');
            }
        });
    });

    /* ---------- Hero video: play / pause + reduced motion ---------- */
    var video = $('#heroVideo');
    var playBtn = $('#heroPlay');

    function syncPlayBtn() {
        var paused = video.paused;
        playBtn.innerHTML = paused ? '<i class="fas fa-play"></i>' : '<i class="fas fa-pause"></i>';
        playBtn.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
    }

    if (video && playBtn) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
            video.removeAttribute('autoplay');
            video.pause();
        }

        playBtn.addEventListener('click', function () {
            if (video.paused) { video.play(); } else { video.pause(); }
        });
        video.addEventListener('play', syncPlayBtn);
        video.addEventListener('pause', syncPlayBtn);
        syncPlayBtn();
    }

    /* ---------- Count up ---------- */
    function countUp(el) {
        var target = parseInt(el.getAttribute('data-count'), 10);
        var start = null;
        var duration = 1600;

        function step(ts) {
            if (!start) start = ts;
            var p = Math.min((ts - start) / duration, 1);
            el.textContent = Math.floor(target * (1 - Math.pow(1 - p, 3)));
            if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
    }

    /* ---------- Scroll reveal ---------- */
    var revealEls = $$('[data-reveal]');
    var counters = $$('[data-count]');

    if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var el = entry.target;
                if (el.hasAttribute('data-count')) {
                    countUp(el);
                } else {
                    el.classList.add('is-visible');
                }
                io.unobserve(el);
            });
        }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

        revealEls.concat(counters).forEach(function (el) { io.observe(el); });
    } else {
        revealEls.forEach(function (el) { el.classList.add('is-visible'); });
        counters.forEach(function (el) { el.textContent = el.getAttribute('data-count'); });
    }


    /* ---------- Service panels (expand + autoplay) ---------- */
    var panelWrap = $('#svcPanels');
    var panels = panelWrap ? $$('.svc-panel', panelWrap) : [];
    var isDesktop = window.matchMedia('(min-width: 992px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hovering = false;
    var inView = false;

    function activate(panel) {
        panels.forEach(function (p) { p.classList.toggle('is-active', p === panel); });
        restartBar();
    }

    function restartBar() {
        panelWrap.classList.remove('is-playing');
        if (reduceMotion || hovering || !inView || !isDesktop.matches) return;
        void panelWrap.offsetWidth; // restart the CSS animation
        panelWrap.classList.add('is-playing');
    }

    panels.forEach(function (panel) {
        panel.addEventListener('mouseenter', function () { if (isDesktop.matches) activate(panel); });
        panel.addEventListener('focus', function () { activate(panel); });
        panel.addEventListener('click', function () { activate(panel); });

        // When the progress bar fills, move to the next panel
        $('.svc-panel__bar', panel).addEventListener('animationend', function () {
            activate(panels[(panels.indexOf(panel) + 1) % panels.length]);
        });
    });

    if (panelWrap) {
        panelWrap.addEventListener('mouseenter', function () { hovering = true; restartBar(); });
        panelWrap.addEventListener('mouseleave', function () { hovering = false; restartBar(); });
    }

    if (panelWrap && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
            inView = entries[0].isIntersecting;
            restartBar();
        }, { threshold: 0.4 }).observe(panelWrap);
    }

    /* ---------- Lightbox ---------- */
    var lb = $('#lightbox');
    var lbImg = $('img', lb);
    var lbCap = $('figcaption', lb);
    var items = $$('[data-lightbox]');
    var current = 0;

    function show(i) {
        current = (i + items.length) % items.length;
        lbImg.src = items[current].getAttribute('href');
        lbImg.alt = items[current].getAttribute('data-caption') || '';
        lbCap.textContent = items[current].getAttribute('data-caption') || '';
    }

    function closeLb() {
        lb.classList.remove('is-open');
        lb.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('nav-open');
    }

    items.forEach(function (a) {
        a.addEventListener('click', function (e) {
            e.preventDefault();
            show(items.indexOf(a));
            lb.classList.add('is-open');
            lb.setAttribute('aria-hidden', 'false');
            document.body.classList.add('nav-open');
        });
    });

    $('.lightbox__close', lb).addEventListener('click', closeLb);
    $('.lightbox__nav--prev', lb).addEventListener('click', function () { show(current - 1); });
    $('.lightbox__nav--next', lb).addEventListener('click', function () { show(current + 1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) closeLb(); });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeLb(); setMenu(false); }
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'ArrowLeft') show(current - 1);
        if (e.key === 'ArrowRight') show(current + 1);
    });
})();
